import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

// Note: the term `fill` is used for the `stroke` color to match other svgs api.
export const RadioStarUnselect = ({
  size = 16,
  title = 'Unselect',
  fill = colors.silverSandAlt,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 36.149 34.582">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M34.044,23.536a1.164,1.164,0,0,0-1.023-.807l-10.72-.9-4.17-9.914a1.18,1.18,0,0,
0-1.082-.728,1.151,1.151,0,0,0-1.082.728L11.8,21.825l-10.72.9a1.164,1.164,0,0,
0-1.023.807,1.212,1.212,0,0,0,.354,1.259l8.124,7.022L6.092,42.282A1.177,1.177,
0,0,0,7.843,43.56l9.206-5.567,9.206,5.567a1.153,1.153,0,0,0,.61.177,1.239,1.239,
0,0,0,.688-.216A1.144,1.144,0,0,0,28,42.3L25.566,31.837l8.124-7.022A1.182,1.182,0,0,0,34.044,23.536Z
`}
        transform="translate(1.019 -10.183)"
        fill="none"
        stroke={fill}
        strokeWidth="2"
      />
    </svg>
  );
};
